import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    generalInformation: null,
    committee: null,
    selectedCommitteeId: null,
    meetingCommonInfo: null,
    actionState: 'add',
    agendaID: null,
    agenda: null,
    screenStarted: false,
    error: null,
    hasChangeGeneralInformation: false,
    hasChangeCommitte: false,
    initialGeneralInformation: null,
};

export const meetingSlice = createSlice({
    name: 'meeting',
    initialState,
    reducers: {
        screenStart: (state) => {
            state.screenStarted = true;
            state.error = null;
        },
        generalInformationCapture: (state, action) => {            
            state.generalInformation = action.payload;
        },
        initialGeneralInformationCapture: (state, action) => {            
            state.initialGeneralInformation = action.payload;
        },
        commonInformationCapture: (state, action) => {
            state.meetingCommonInfo = action.payload;
        },
        committeeCapture: (state, action) => {
            state.committee = action.payload;
        },
        agendaCapture: (state, action) => {
            state.agenda = action.payload;
        },
        agendaIDCapture: (state, action) => {
            state.agendaID = action.payload;
        },
        agendaReplace: (state, action) => {
            state.agenda = action.payload;
        },
        selectedCommitteeIdCapture: (state, action) => {
            state.selectedCommitteeId = action.payload;
        },
        actionStateCapture: (state, action) => {
            state.actionState = action.payload;
        },
           screenEnded: (state) => {
            state.screenStarted = false;
            state.generalInformation = null;
            state.initialGeneralInformation = null;
            state.hasChangeCommitte = false;
            state.committee = null;
            state.selectedCommitteeId = null;
            state.meetingCommonInfo = null;
            state.agendaID = null;
            state.actionState = 'add';
            state.agenda = null;
            state.error = null;
            state.hasChangeGeneralInformation = false;
        },
        hasChangeGeneralInformationCapture:(state,action)=>{
            state.hasChangeGeneralInformation = action.payload;
        },
        hasChangeCommitteCapture:(state,action)=>{            
            state.hasChangeCommitte = action.payload;
        }
    },
});

export const { screenStart, screenEnded, generalInformationCapture, committeeCapture, agendaCapture, selectedCommitteeIdCapture, actionStateCapture, agendaReplace, agendaIDCapture, commonInformationCapture ,hasChangeGeneralInformationCapture,initialGeneralInformationCapture,hasChangeCommitteCapture} = meetingSlice.actions;

export default meetingSlice.reducer;